import { exportCustomModel } from '@/api/registry';
import DownloadLink from '@/components/core/DownloadLink';
import PropTypes from 'prop-types';

const DownloadCustomModelLink = ({ customModel }) =>
  customModel?.model_type === 'excel' && <DownloadLink to={exportCustomModel(customModel.id)} />;

DownloadCustomModelLink.propTypes = {
  customModel: PropTypes.shape({
    model_type: PropTypes.string,
    id: PropTypes.string,
  }),
};
export default DownloadCustomModelLink;
